<template>
  <div id="set-control-layer">
    <header>
      <div class="header-center">
        <a href="https://www.yuanquanyun.com.cn/">
          <svg-icon class="logo" iconClass="logo" />
        </a>
        <!-- <span class="logo-text">元全云电子合同</span> -->
        <span class="logo-s-title"></span>
        <a href="javascript:;" @click="returnFlow" class="return-index">
          < 返回</a>
      </div>
    </header>
    <div class="setcontrol-content" id="main">
      <div class="set-sign-control">
        <div class="set-title">设置签署位置</div>
        <div class="select-sign-box">
          <el-select v-model="sequence" placeholder="请选择">
            <el-option v-for="item in signatoryList" :key="item.id" :value="item.sequence" :label="(item.subjectName)">
            </el-option>
          </el-select>
        </div>
        <!-- <div class="sign-time">
          <el-select v-model="isTime" placeholder="请选择">
            <el-option value="0" label="显示签署时间"></el-option>
            <el-option value="1" label="不显示签署时间"></el-option>
          </el-select>
        </div> -->
        <!-- <div class="drop-sign" v-drop="{addCustom}">
          <span>签署</span>
          <i class="el-icon-edit-outline"></i>
        </div> -->
        <div class="drop-box clearfix">
          <div class="drop-item" v-if="isCompanyIdentity">
            <div class="drop-s autograph" v-if="isCompanyIdentity.signingBody != 1" :data-pagingpos="pagingPos"
              :data-ispaging="isPaging" :data-sealtype="0" v-drop="{ addCustom }">
              <img src="../../assets/images/sign/sign1.png" alt="">
            </div>
          </div>
          <div class="drop-item" v-if="isCompanyIdentity">
            <div class="drop-s autograph" v-if="isCompanyIdentity.signingBody == 1" :data-pagingpos="pagingPos"
              :data-ispaging="isPaging" :data-sealtype="1" v-drop="{ addCustom }">
              <img src="../../assets/images/sign/sign1.png" alt="">
            </div>
          </div>
          <div class="drop-item" v-if="isCompanyIdentity">
            <div class="drop-s signature" :data-pagingpos="pagingPos" :data-ispaging="isPaging"
              v-if="isCompanyIdentity.signingBody == 1" :data-sealtype="2" v-drop="{ addCustom }">
              <img src="../../assets/images/sign/sign2.png" alt="">
            </div>
          </div>
          <div class="drop-item">
            <div class="drop-s s-date" :data-pagingpos="pagingPos" :data-ispaging="isPaging" v-if="isPaging == '0'"
              :data-sealtype="3" v-drop="{ addCustom }">
              <img src="../../assets/images/sign/date-icon.png" alt="">
            </div>
          </div>
          <div class="drop-item" v-if="isCompanyIdentity">
            <div class="drop-s legal" :data-pagingpos="pagingPos" :data-ispaging="isPaging"
              v-if="isCompanyIdentity.signingBody == 1" :data-sealtype="4" v-drop="{ addCustom }">
              <img src="../../assets/images/sign/legal-icon.png" alt="">
            </div>
          </div>
          <div class="drop-texts">
            <p>签名</p>
            <p v-if="isCompanyIdentity">
              <span v-if="isCompanyIdentity.signingBody == 1">签章</span>
            </p>
            <p v-if="isPaging == '0'">日期</p>
            <p v-if="isCompanyIdentity" style="margin-top: 75px; margin-left:-22px; width:100px">
              <span v-if="isCompanyIdentity.signingBody == 1">法定代表人章</span>
            </p>
          </div>
        </div>
        <div class="paging-seal-box" v-if="contractImgs.length > 1">
          <p>是否为骑缝章</p>
          <el-select v-model="isPaging" placeholder="是否为骑缝章">
            <el-option value="0" label="否"></el-option>
            <el-option value="1" label="是"></el-option>
          </el-select>
        </div>
        <!-- <div class="paging-seal-box" v-if="isPaging != '0'">
          <el-select v-model="pagingPos" placeholder="选择骑缝章位置">
            <el-option value="left" label="左骑缝"></el-option>
            <el-option value="top" label="上骑缝"></el-option>
            <el-option value="right" label="右骑缝"></el-option>
            <el-option value="bottom" label="下骑缝"></el-option>
          </el-select>
        </div> -->
      </div>

      <div class="contract-content" ref="cmain">
        <div class="contract-img-content">
          <div class="contract-imgs" id="contract-imgs" ref="contract">
            <img v-for="(contract, index) in contractImgs" :key="index" :src="contract" class="contract-img" alt="">
          </div>
          <div class="custom-drag" v-dropcustom="{ editCustom, positionList }" v-for="(drag, index) in positionList"
            :key="index" :style="{ left: drag.left + 'px', top: drag.top + 'px' }" :data-cid="drag.createdId"
            :data-pagingpos="drag.pagingPos" :data-ispaging="drag.isPaging" :data-page="drag.page">
            <div class="custom-content"></div>
            <span class="custom-drag-title" v-show="drag.sType != '3'">{{ drag.sealType }}</span>
            <span class="custom-drag-title" v-show="drag.sType == '3'">日期</span>
            <span class="custom-drag-time" v-show="isTime == '0'"></span>
            <div class="custom-drag-header clearfix">
              <span style="float: left; width: 93px; height: 33px; overflow: hidden;">{{ drag.signatory }}</span>
              <span style="float:right;" @click="deleteSealBox(drag.createdId)">X</span>
            </div>
          </div>
        </div>


      </div>

      <div class="contract-page">
        <div class="all-page">
          <div class="page-item" v-for="(contract, index) in contractImgs" :key="index">
            <div class="page-img" @click="jumpPage(index)">
              <img :src="contract" alt="">
            </div>
            <p class="page-text">第{{ index + 1 }}页</p>
          </div>
        </div>

      </div>
    </div>
    <div class="submit-btn">
      <el-button type="primary" :disabled="clickSubmit" @click="toSetSignPosition(isProgess ? '2' : '5')">{{ progessText1 }}
      </el-button>
      <el-button type="primary" :disabled="clickSubmit" @click="toSetSignPosition(isProgess ? '1' : '4')">{{ progessText2 }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
import eHeader from '@/components/eHeader'
import { getContractImgsApi } from '@/api/sign/flow'
import { getSignatoryListApi, setContractInitiateApi, getIsNotProgessApi } from '@/api/sign/set-control'
import { getToken } from '@/utils/auth'
export default {
  components: {
    eHeader
  },
  computed: {
    isCompanyIdentity() {
      var curSignatory;
      this.signatoryList.forEach(sign => {
        if (sign.sequence === this.sequence) {
          curSignatory = sign
        }
      })
      return curSignatory
    }
  },
  directives: {
    drop: {
      inserted: function (el, binding) {
        function getDataset(ele) {
          if (ele.dataset) {
            return ele.dataset;
          } else {
            var attrs = ele.attributes, //元素的属性集合
              dataset = {},
              name,
              matchStr;

            for (var i = 0; i < attrs.length; i++) {
              //是否是data- 开头
              matchStr = attrs[i].name.match(/^data-(.+)/);
              if (matchStr) {
                //data-auto-play 转成驼峰写法 autoPlay
                name = matchStr[1].replace(/-([\da-z])/gi, function (all, letter) {
                  return letter.toUpperCase();
                });
                dataset[name] = attrs[i].value;
              }
            }
            return dataset;
          }
        }
        var signId = binding.value.signatoryId
        var disX = 0;
        var disY = 0;
        var contractImgs = document.querySelector('#contract-imgs').parentNode.parentNode;
        var contract = document.querySelector('#contract-imgs');
        var main = document.querySelector('#main')
        var sealType = ''
        var isPaging;
        var pagingPos;
        el.onmousedown = function () {
          el.style.background = '#ccc';
          var event = event || window.event;
          disX = event.clientX - this.offsetLeft;
          disY = event.clientY - this.offsetTop;
          var cloneTemp = el.cloneNode(true);
          sealType = getDataset(el).sealtype
          isPaging = getDataset(el).ispaging
          pagingPos = getDataset(el).pagingpos

          cloneTemp.style.left = this.currentStyle ? this.currentStyle["left"] : getComputedStyle(this, null)[
            "left"];
          cloneTemp.style.top = this.currentStyle ? this.currentStyle["top"] : getComputedStyle(this, null)[
            "top"];
          cloneTemp.style.cursor = 'grab';
          el.parentNode.appendChild(cloneTemp);

          document.onmousemove = function (event) {
            var event = event || window.event;
            var iL = event.clientX - disX;
            var iT = event.clientY - disY;
            var maxL = document.documentElement.clientWidth - el.offsetWidth;
            var maxT = document.documentElement.clientHeight - el.offsetHeight;
            iL <= 0 && (iL = 0);
            iT <= 0 && (iT = 0);
            iL >= maxL && (iL = maxL);
            iT >= maxT && (iT = maxT);
            cloneTemp.style.left = iL + "px";
            cloneTemp.style.top = iT + "px";
            return false;
          }

          document.onmouseup = function (event) {
            var event = event || window.event;
            document.onmousemove = null;
            document.onmouseup = null;
            if (event.clientX >= (contractImgs.offsetLeft + main.offsetLeft) && event.clientY >= contractImgs
              .offsetTop && event.clientX <= (contractImgs.offsetLeft + main.offsetLeft + contractImgs
                .offsetWidth)) {
              var left = event.clientX - 65 - main.offsetLeft - contractImgs.offsetLeft;
              var top = event.clientY - 65 - main.offsetTop + contractImgs.scrollTop;


              if (isPaging == '1') {
                if (pagingPos === 'left') {
                  left = 0
                } else if (pagingPos === 'top') {
                  top = 0
                } else if (pagingPos === 'right') {
                  left = contractImgs.offsetWidth - 129
                } else if (pagingPos === 'bottom') {
                  top = contractImgs.offsetHeight - 129
                }
              } else {

                if (left <= 0) {
                  left = 0
                }
                if (top <= 0) {
                  top = 0
                }
                if (left >= contractImgs.offsetWidth - 129) {
                  left = contractImgs.offsetWidth - 129
                }
                if (top >= contract.offsetHeight - 129) {
                  top = contract.offsetHeight - 129
                }

              }

              let page = Math.ceil(top / contract.children[0].offsetHeight)

              if (page <= 1) {
                page = 1
              }

              binding.value.addCustom({
                left: left,
                top: top,
                page: page,
                width: contract.children[0].offsetWidth,
                height: contract.children[0].offsetHeight,
                sealType: sealType,
                isPaging: isPaging,
                pagingPos: pagingPos,
                createdId: new Date().getTime()
              })
            }

            el.parentNode.removeChild(cloneTemp)
            el.style.background = '#fff';
          }
        }
      }
    },
    dropcustom: {
      inserted: function (el, binding) {
        function getDataset(ele) {
          if (ele.dataset) {
            return ele.dataset;
          } else {
            var attrs = ele.attributes, //元素的属性集合
              dataset = {},
              name,
              matchStr;

            for (var i = 0; i < attrs.length; i++) {
              //是否是data- 开头
              matchStr = attrs[i].name.match(/^data-(.+)/);
              if (matchStr) {
                //data-auto-play 转成驼峰写法 autoPlay
                name = matchStr[1].replace(/-([\da-z])/gi, function (all, letter) {
                  return letter.toUpperCase();
                });
                dataset[name] = attrs[i].value;
              }
            }
            return dataset;
          }
        }
        var disX = 0;
        var disY = 0;
        var contractImgs = document.querySelector('#contract-imgs').parentNode.parentNode;
        var contract = document.querySelector('#contract-imgs');
        var positionList = binding.value.positionList
        var thisPosition = {}
        var isPaging;
        var pagingPos;
        var pageH;
        var page;

        el.onmousedown = function () {
          var event = event || window.event;
          disX = event.clientX - this.offsetLeft;
          disY = event.clientY - this.offsetTop;

          isPaging = getDataset(el).ispaging
          pagingPos = getDataset(el).pagingpos

          pageH = contract.children[0].offsetHeight
          // page = Math.ceil(el.offsetTop/pageH)
          page = getDataset(el).page

          positionList.forEach(item => {
            if (item.createdId == getDataset(el).cid) {
              thisPosition = item
            }
          })

          document.onmousemove = function (event) {
            var event = event || window.event;
            var iL = event.clientX - disX;
            var iT = event.clientY - disY;
            var maxL = contractImgs.clientWidth - el.offsetWidth;
            var maxT = (thisPosition.page) * (contract.children[0].clientHeight + 2) - el.offsetHeight;

            if (isPaging == '1') {
              if (pagingPos === 'left') {
                iL = 0
                if (iT <= 0) {
                  iT = 0
                }
              } else if (pagingPos === 'top') {
                iT = 0
                iL <= 0 && (iL = 0);
                iL >= maxL && (iL = maxL);
              } else if (pagingPos === 'right') {
                iL = maxL

                // console.log(iT, (thisPosition.page-1)*(contract.children[0].clientHeight+2))
                if (iT <= (page - 1) * (contract.children[0].clientHeight + 2)) {
                  iT = (page - 1) * (contract.children[0].clientHeight + 2)
                }

                if (iT > (page) * (contract.children[0].clientHeight + 2) - el.offsetHeight) {
                  iT = (page) * (contract.children[0].clientHeight + 2) - el.offsetHeight
                }

              } else if (pagingPos === 'bottom') {
                iT = (contract.children[0].clientHeight + 2) - el.offsetHeight
                iL <= 0 && (iL = 0);
                iL >= maxL && (iL = maxL);
              }
            } else {
              iL <= 0 && (iL = 0);
              iL >= maxL && (iL = maxL);
              if (iT <= 0) {
                iT = 0
              } else {
                if (iT <= (thisPosition.page - 1) * (contract.children[0].clientHeight + 2)) {
                  iT = (thisPosition.page - 1) * (contract.children[0].clientHeight + 2)
                }

                if (iT > (thisPosition.page) * (contract.children[0].clientHeight + 2) - el.offsetHeight) {
                  iT = (thisPosition.page) * (contract.children[0].clientHeight + 2) - el.offsetHeight
                }
              }
            }



            el.style.left = iL + "px";
            el.style.top = iT + "px";
            return false;
          }

          document.onmouseup = function (event) {
            document.onmousemove = null;
            document.onmouseup = null;
            var top;

            if (isPaging == '1') {
              top = el.offsetTop - ((page - 1) * pageH)
            } else {
              top = el.offsetTop
            }
            binding.value.editCustom({
              isPaging: isPaging,
              left: el.offsetLeft,
              top: top,
              page: page,
              cid: getDataset(el).cid,
            })


          }
        }

      }
    }

  },
  created() {
    this.loadingInstance = Loading.service({
      fullscreen: true
    });
  },
  mounted() {
    this.getSignatoryListHandle()
    this.getContractImgsHandle()
    this.getIsNotProgessHandle()
  },
  watch: {
    contractH(val) {
      console.log(val)
      if (val > 2) {
        clearInterval(this.setContractH)
      }
    }
  },
  data() {
    return {
      loadingInstance: null,
      contractImgs: [
      ],
      clickSubmit: false,
      setContractH: null,
      contractH: 0,
      stitle: ' ',
      isTime: "0",
      scrollTop: 0,
      signatoryId: '',
      sequence: null,
      signatoryList: [
      ],
      positionList: [
        // {
        //   sealType: '个人',
        //   signatory: '甲方',
        //   left: 100,
        //   top: 0,
        //   page: 1,
        //   createdId: '1582353511381',
        //   userId: 123
        // },
        // {
        //   sealType: '企业',
        //   signatory: '乙方',
        //   left: 200,
        //   top: 0,
        //   page: 1,
        //   createdId: new Date().getTime(),
        //   userId: 456
        // },
        // {
        //   sealType: '企业',
        //   signatory: '乙方',
        //   left: 300,
        //   top: 0,
        //   page: 1,
        //   createdId: '1582354120019',
        //   userId: 456
        // },
        // {
        //   sealType: '个人',
        //   signatory: '甲方',
        //   left: 400,
        //   top: 0,
        //   page: 1,
        //   createdId: '1582353511382',
        //   userId: 123
        // },
      ],
      isPaging: "0",
      pagingPos: "right",
      isProgess: false,
      progessText1: '送审',
      progessText2: '保存待送审'
    }
  },
  methods: {
    getIsNotProgessHandle() {
      getIsNotProgessApi({
        contractId: this.$route.query.contractId
      }).then(res => {
        console.log(res)
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          if (res.data.success == 'false') {
            this.progessText1 = '发送'
            this.progessText2 = '保存待发送'
            this.isProgess = false
          } else {
            this.progessText1 = '送审'
            this.progessText2 = '保存待送审'
            this.isProgess = true
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getContractImgsHandle() {
      getContractImgsApi(this.$route.query.contractId).then(res => {
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          this.loadingInstance.close();
        });
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.contractImgs = res.data.pngList.map(el => {
            return (((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + el + getToken() + '&nocache=' + new Date().getTime())
          })
          this.$nextTick(() => {
            var _this = this
            document.querySelector('#contract-imgs').children[0].onload = function () {
              _this.setContractH = setInterval(() => {
                _this.contractH = document.querySelector('#contract-imgs').children[0].offsetHeight
                // console.log('签署时height：'+_this.contractH)
                // console.log('签署时width：'+document.querySelector('#contract-imgs').children[0].offsetWidth)
              }, 500)
            }

          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    returnFlow() {
      this.$router.push({
        path: '/flow',
        query: {
          contractId: this.$route.query.contractId
        }
      })
    },
    addCustom(data) {
      var parr = []
      this.signatoryList.forEach(item => {
        if (item.sequence === this.sequence) {
          parr.push(item)
        }
      })

      var sealSubject = '' // 0是个人，1是经办人。2是企业
      sealSubject = data.sealType
      // if (parr[0].signingBody == '0' && data.sealType == '0') {
      //   sealSubject = '0'
      // } else if (parr[0].signingBody == '1' && data.sealType == '0') {
      //   sealSubject = '1'
      // } else if (parr[0].signingBody == '1' && data.sealType == '1') {
      //   sealSubject = '0'
      // } else {
      //   sealSubject = data.sealType
      // }

      var sealType;

      if (data.sealType == '0') {
        sealType = '个人章'
      } else if (data.sealType == '1') {
        sealType = '经办人章'
      } else if (data.sealType == '2') {
        sealType = '企业章'
      } else if (data.sealType == '3') {
        sealType = '日期'
      } else if (data.sealType == '4') {
        sealType = '法定代表人章'
      }

      if (data.isPaging == 1) {
        this.contractImgs.forEach((cImg, index) => {
          this.positionList.push({
            left: data.left,
            top: data.top + this.contractH * index,
            page: parseInt(index + 1),
            createdId: data.createdId,
            sealType: sealType,
            signatory: parr[0].subjectName,
            userId: parr[0].sequence,
            width: data.width,
            height: data.height,
            sType: data.sealType,
            sealSubject: sealSubject,
            isPaging: data.isPaging,
            pagingPos: data.pagingPos,
          })
        })
      } else {
        this.positionList.push({
          left: data.left,
          top: data.top,
          page: data.page,
          createdId: data.createdId,
          sealType: sealType,
          signatory: parr[0].subjectName,
          userId: parr[0].sequence,
          width: data.width,
          height: data.height,
          sType: data.sealType,
          sealSubject: sealSubject,
          isPaging: data.isPaging,
          pagingPos: data.pagingPos,
        })
      }



      console.log(this.positionList)
    },
    editCustom(data) {
      this.positionList.forEach(position => {

        if (position.createdId == data.cid) {
          if (data.isPaging == '1') {
            position.left = data.left
            position.top = data.top + this.contractH * (position.page - 1)
          } else {
            position.left = data.left
            position.top = data.top
          }


        }
      })
    },
    deleteSealBox(cid) {
      // this.positionList.forEach((pos, index) => {
      //   if (pos.createdId == cid) {
      //     this.positionList.splice(index, 1)
      //   }
      // })
      // window.event.cancelBubble = true

      this.positionList = this.positionList.filter((item, index, arr) => {
        return item.createdId != cid
      })
    },
    jumpPage(page) {
      var sTop = 0;
      var allImgs = this.$refs.contract.querySelectorAll('img')
      for (var i = 0; i < page; i++) {
        sTop += (allImgs[i].offsetHeight)
      }
      this.$refs.cmain.scrollTop = sTop;
    },
    getSignatoryListHandle() {
      getSignatoryListApi(this.$route.query.contractId).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.signatoryList = res.data.signatoryList
          console.log(this.signatoryList)
          // this.signatoryId = this.signatoryList[0].id
          this.sequence = this.signatoryList[0].sequence
        }
      }).catch(err => {
        console.log(err)
      })
    },
    toSetSignPosition(status) {
      let userList = [];  // 取出对应签署方id
      let bOK = true
      let poslist = []
      this.signatoryList.forEach(item => {
        userList.push({
          sequence: item.sequence,
          positionList: []
        })
      })


      // console.log(this.positionList)

      function unique(arr) { // 去重
        const res = new Map();
        return arr.filter((a) => !res.has(a.createdId) && res.set(a.createdId, 1))
      }

      poslist = unique(this.positionList)

      // 对比数组，把签署方id相同的push到对应数组里
      poslist.forEach(position => {
        userList.forEach((user, index) => {
          // console.log(position)
          console.log(user)
          if (position.userId == user.sequence) {
            var top = (position.top - position.height * (position.page - 1)) / position.height
            var sealHeight = (129 / position.height).toFixed(6)
            // console.log('拖章时top：'+ (position.top - position.height * (position.page-1)))
            // console.log('拖章时height：'+ position.height)
            // console.log('拖章时width：'+ position.width)
            // console.log('拖章时百分比：' + top)
            // // console.log('拖章时章高度：'+ sealHeight)
            // console.log('--------------------------------')
            if (top > (1 - sealHeight)) {
              top = (1 - sealHeight).toFixed(6)
            }

            if (top < 0) {
              top = 0
            }

            if (position.page > this.contractImgs.length) {
              this.$message({
                showClose: true,
                message: '签署框page错误，请重新页面重新指定签署位置！',
                type: 'warning'
              });

              return
            }

            console.log(top)
            userList[index].positionList.push({
              x: (position.left / position.width).toFixed(6),
              y: top,
              page: position.page,
              sealType: position.isPaging, // 0 普通签章；1 骑缝章
              sealSubject: position.sealSubject
            })
          }
        })
      })

      for (var i = 0; i < userList.length; i++) {
        if (userList[i].positionList.length === 0) {
          this.$message({
            showClose: true,
            message: '请指定签署位置！',
            type: 'warning'
          });
          bOK = false
          return
        } else {
          // console.log(userList[i].positionList)
          for (var j = 0; j < userList[i].positionList.length; j++) {
            if (userList[i].positionList[j].sealSubject == '0') {
              bOK = true
              break
            } else {
              bOK = false
            }
          }
        }
      }

      for (var i = 0; i < userList.length; i++) {
        for (var j = 0; j < this.signatoryList.length; j++) {
          // 根据id查找签署方
          if (userList[i].sequence === this.signatoryList[j].sequence) {
            // 企业情况下，需要拖企业章与经办人章
            if (this.signatoryList[j].signingBody === 1) {
              userList[i].sealSubjectList = []
              for (var z = 0; z < userList[i].positionList.length; z++) {

                userList[i].sealSubjectList.push(userList[i].positionList[z].sealSubject)
                userList[i].sealSubjectList = Array.from(new Set(userList[i].sealSubjectList))

              }
            }
          }
        }
      }

      for (var i = 0; i < userList.length; i++) {
        if (userList[i].sealSubjectList) {
          for (var j = 0; j < userList[i].sealSubjectList.length; j++) {
            if (userList[i].sealSubjectList[j] == '2') {
              console.log(bOK)
              bOK = true
              break
            } else {
              bOK = false
            }
          }
        }

      }

      if (!bOK) {
        this.$message({
          showClose: true,
          message: '请指定签署位置！',
          type: 'warning'
        });
        return
      }

      if (bOK) {
        this.clickSubmit = true
        setContractInitiateApi({
          userList: userList,
          status: status,
          contractId: this.$route.query.contractId
        }).then(res => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
            this.clickSubmit = false
          } else {
            if (status == '5' && this.$route.query.isFirst == 'true' && (this.$route.query.isSame + '') == 'true') {
              this.$router.push({
                path: '/sign',
                query: {
                  contractId: this.$route.query.contractId,
                  signType: this.$route.query.companyId ? '1' : '0',
                  companyId: this.$route.query.companyId
                }
              })
            } else {
              this.$message({
                showClose: true,
                message: '发起成功！',
                type: 'success'
              });

              this.$router.push({
                path: '/'
              })
            }
            this.clickSubmit = false
          }
        }).catch(err => {
          console.log(err)
          this.clickSubmit = false
        })
      }
    }
  }
}
</script>
<style scoped>
#set-control-layer {
  background: #f0f0f5;
  height: 100vh;
  overflow: hidden;
}

header {
  width: 100%;
  height: 71px;
  background: rgba(35, 43, 58, 1);
  box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
  line-height: 71px;
  overflow: hidden;
}

.header-center {
  width: 1200px;
  margin: 0 auto;
  line-height: 71px;
  height: 71px;
  overflow: hidden;
  position: relative;
}

.logo {
  margin-top: 16px;
  margin-left: 0;
  width: 126px;
  float: left;
}

.logo-text {
  margin-left: 42px;
  font-size: 24px;
  color: #ffffff;
}

.logo-s-title {
  font-size: 24px;
  color: #ffffff;
  margin-left: 24px;
}

.return-index {
  height: 71px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 24px;
  color: #ffffff;
  line-height: 71px;
}

.setcontrol-content {
  width: 1200px;
  margin: 30px auto 0;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.set-sign-control {
  width: 238px;
  background: white;
  position: relative;
  z-index: 9;
}

.set-title {
  font-size: 18px;
  height: 23px;
  line-height: 26px;
  color: #333333;
  border-left: 3px solid #E85052;
  text-indent: 13px;
  margin: 32px 0 0 27px;
}

.select-sign-box {
  width: 152px;
  margin: 30px auto 0;
}

.drop-sign {
  width: 152px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  text-indent: 20px;
  color: rgba(0, 0, 0, 0.5);
  border: 1px dashed rgba(0, 0, 0, 0.3);
  cursor: grab;
  background-color: white;
  position: absolute;
  left: 43px;
  /* top: 214px; */
  top: 154px;
  z-index: 9；
}

.sign-time {
  width: 152px;
  margin: 29px auto 0;

}

.contract-img-content {
  /* height: calc(100vh - 134px);
    overflow-y: auto;
    position: relative; */

  position: absolute;
  left: 0;
  top: 30px;
  right: 0;
  bottom: 0;
  z-index: 2;
}

.contract-content {
  width: 685px;
  background: white;
  position: relative;
  height: calc(100vh - 101px);
  overflow: auto;
}

.contract-page {
  width: 238px;
  background: white;
  height: calc(100vh - 101px);
  overflow: auto;
}

.contract-imgs {
  position: relative;
  z-index: 1;
}

.contract-imgs img {
  display: block;
  width: 100%;
  height: auto;
  border-bottom: 2px solid #eee;
  box-sizing: content-box;
  -ms-box-sizing: content-box;
}

.contract-img {
  width: 685px;
}

.custom-drag {
  width: 127px;
  height: 127px;
  border: 1px solid rgba(51, 204, 204, 1);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  cursor: move;
  /* box-sizing: content-box;
    -ms-box-sizing: content-box; */
}

.custom-content {
  width: 127px;
  height: 127px;
  background: rgba(255, 255, 255, .7);
  position: relative;
  z-index: 1;
}

.custom-drag-title {
  font-size: 16px;
  color: #000000;
  display: block;
  width: 127px;
  top: 50px;
  display: block;
  position: absolute;
  z-index: -1;
  text-align: center;
}

.custom-drag-time {
  position: absolute;
  bottom: 8px;
  text-align: center;
  font-size: 16px;
  color: #000;
  display: block;
  width: 127px;
}

.custom-drag-header {
  width: 109px;
  height: 33px;
  background: rgba(51, 204, 204, 1);
  line-height: 33px;
  font-size: 16px;
  color: #ffffff;
  padding: 0 10px;
  /* display: flex;
    justify-content: space-between; */
  position: absolute;
  left: -1px;
  top: -33px;
}

.custom-delete {
  font-size: 14px;
  width: 60px;
  height: 22px;
  background: rgba(0, 0, 0, .5);
  text-align: center;
  color: #ffffff;
  display: block;
  line-height: 22px;
  position: absolute;
  left: 30px;
  bottom: -22px;
  display: none;
}

.all-page {
  width: 180px;
  margin: 30px auto 0;
}

.page-item {
  position: relative;
  height: 230px;
  margin-bottom: 22px;
}

.page-img {
  width: 177px;
  height: 198px;
  border: 1px solid rgba(240, 240, 245, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}

.page-img img {
  display: block;
  width: 100%;
}

.page-text {
  text-align: center;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #333333;
}

.submit-btn {
  width: 336px;
  height: 50px;
  position: fixed;
  left: 50%;
  bottom: 50px;
  margin-left: -168px;
  color: #FFFFFF;
  font-size: 16px;
  z-index: 999;
}

.submit-btn button {
  width: 150px;
  height: 50px;
  font-size: 16px;
}

.drop-box {
  width: 152px;
  margin: 0 auto;
}

.drop-s {
  box-sizing: border-box;
  width: 46px;
  height: 46px;
  border: 1px solid rgba(240, 240, 245, 1);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: grab;
  /* position: relative; */
  /* position: relative; */
}

.autograph {
  position: absolute;
  left: 45px;
  top: 154px;
}

.signature {
  position: absolute;
  left: 97px;
  top: 154px;
}

.s-date {
  position: absolute;
  left: 150px;
  top: 154px;
}

.drop-texts {
  width: 152px;
  /* display: flex;
    justify-content: space-between; */
  margin-top: 90px;
}

.drop-texts p {
  text-align: center;
  font-size: 14px;
  color: #333333;
  margin-top: 6px;
  width: 46px;
  margin-left: 7px;
  float: left;
}

.drop-texts p:first-child {
  margin-left: 0;
}

.paging-seal-box {
  width: 152px;
  margin: 15px auto;
}

.paging-seal-box p {
  font-size: 14px;
  margin-bottom: 8px;
  color: #333333;
}

.legal {
  position: absolute;
  left: 45px;
  top: 254px;
}
</style>